import { Body, BodyColor, BodyType, Heading, TypographyColor, TypographyType } from "../../ui-elements";

interface WIPProps {
  subTitletext: string
}
export const WorkInProgressPoI = ({subTitletext}:WIPProps) => {
    return (
    
        <div className='w-100  d-flex flex-column justify-content-center align-items-center bg-white padding-left-right-5' style={{height:'68%'}}>
        <div className="worknProgressBackgroundImage">
            <div className='position-absolute d-flex flex-column justify-content-center align-items-center' style={{ top: '55%', }}>

                <div className='d-flex flex-column justify-content-center align-items-center'>
                    <Heading
                        title='Work in progress.'
                        type={TypographyType.h5}
                        colour={TypographyColor.primary}
                        classname='padding-top-bottom-4'
                    />
                    <Body
                        type={BodyType.p3}
                        color={BodyColor.primary}
                        classname='text-center padding-left-right-5'
                    >
                        {subTitletext}
                       
                    </Body>

                </div>
            </div>
        </div>
        </div>
    )
}